/* eslint-disable import/order */
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import i18n from "i18n";
import MDButton from "components/Basics/MDButton";
import FilterTableLine from "./FilterTableLine";
import C from "../constants";
import MDTypography from "components/Basics/MDTypography";
import DictionaryMenu from "pages/settings/filters/DictionaryMenu";
import { useState } from "react";

const FiltersTable = ({
	disabled,
	filtersArray,
	handleRemoveFilter,
	onChangeValue,
	handleAddFilter,
	dictionary
}) => {
	const [anchorGroupEl, setAnchorGroupEl] = useState(null);
	// Get all possibles methods for a given type
	function getMethod(type) {
		switch (type) {
			case "string":
				return C.COMP_STRING;
			case "number":
				return C.COMP_NUMBER;
			case "code":
				return C.COMP_CODE;
			case "date":
			case "datetime":
			case "timestamp":
				return C.COMP_DATE;
			default:
				return [];
		}
	}

	return (
		<TableContainer>
			<Table>
				<TableHead
					style={{
						display: "contents"
					}}
				>
					<TableRow>
						<TableCell style={{ width: "33%" }}>
							{i18n.t("SETTINGS.CHARTS.COMPUTE.TEXT.attribute")}
						</TableCell>
						<TableCell style={{ width: "33%" }}>
							{i18n.t("SETTINGS.CHARTS.COMPUTE.TEXT.method")}
						</TableCell>
						<TableCell style={{ width: "33%" }}>
							{i18n.t("SETTINGS.CHARTS.COMPUTE.TEXT.value")}
						</TableCell>
						<TableCell></TableCell>
						<TableCell></TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{filtersArray.map((filter, index) => {
						return (
							<FilterTableLine
								name={filter.name}
								path={filter.path}
								value={filter.value}
								method={filter.method}
								filter={filter.filter}
								methods={getMethod(filter.filter.type)}
								key={index}
								handleRemoveFilter={handleRemoveFilter}
								onChangeValue={onChangeValue}
							/>
						);
					})}
					<TableRow>
						<TableCell colSpan={4} align="left">
							<MDTypography
								variant="button"
								style={{
									fontStyle: "italic"
								}}
							>
								Ajouter un filtre ...
							</MDTypography>
						</TableCell>
						<TableCell>
							<MDButton
								disabled={disabled}
								size="small"
								variant="gradient"
								color="info"
								onClick={e => setAnchorGroupEl(e.target)}
							>
								{i18n.t("SETTINGS.add")}
							</MDButton>
							<DictionaryMenu
								placement="right"
								dictionary={dictionary}
								anchorEl={anchorGroupEl}
								handleInsertText={path => {
									setAnchorGroupEl(null);
									handleAddFilter(path);
								}}
								handleClose={() => setAnchorGroupEl(null)}
								clickableLevels={false}
							/>
						</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default FiltersTable;
